module.exports = __webpack_public_path__ + "static/TPL-logo-pos-A-CMYK-68702e4bf8cfde0f0e9d3fe160077674.svg";